export enum GRID_EDITOR_FIELD {
  NAME = 'name',
  NAME_LA = 'nameLa',
  NAME_EN = 'nameEn',
  TRANSLATIONS = 'translations',
  FIELD = 'field',
  TYPE = 'type',
  FIELD_TYPE = 'fieldType',
  WIDTH = 'width',
  ENUMABLE = 'enumable',
  ITEMS = 'items',
  ENUM_DISPLAY_AS = 'enumDisplayAs',
  MODE_SELECT = 'modelSelect',
  MODE_SELECT_API = 'modelSelectApi',
  DISPLAY = 'display',
  FILTERABLE = 'filterable',
  BIND_BUTTON = 'bindButton',
  FILTER_RANGE = 'filterRange',
  SORTER = 'sorter',
  HIDE_IN_TABLE = 'hideInTable',
  HIDE_IN_SETTING = 'hideInSetting',
  // HIDE_IN_SEARCH = 'hideInSearch',
  FILTERS = 'filters', // lọc trên cột
  FIXED = 'fixed',
  COPYABLE = 'copyable',
  ELLIPSIS = 'ellipsis',
  PREFIX = 'prefix',
  SUFFIX = 'suffix',
  PREFIX_COLOR = 'prefixColor',
  SUFFIX_COLOR = 'suffixColor',
  PREFIX_BY_FIELD = 'prefixByField',
  PREFIX_ITEMS = 'prefixItems',
  SUFFIX_BY_FIELD = 'suffixByField',
  SUFFIX_ITEMS = 'suffixItems',
  WRAP_FIELDS = 'wrapFields',
  WRAP_SEPARATOR = 'wrapSeparator',
  WRAP_LAYOUT = 'wrapLayout',
  MENU_BUTTON = 'menuButton',
  MENU_BUTTON_CONDITION = 'menuButtonConditon',
  VIEW_DETAIL = 'viewDetail',
  VIEW_DETAIL_CTRL = 'viewDetailCtrl',
}

export enum DATA_TYPE {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  BOOLEAN = 'boolean',
  ARRAY_IDS = 'arrayIds',
}

export enum DISPLAY_TYPE {
  MONEY = 'money',
  TEXTAREA = 'textarea',
  OPTION = 'option',
  DATE = 'date',
  DATE_RANGE = 'dateRange',
  DATE_TIME_RANGE = 'dateTimeRange',
  DATE_TIME = 'dateTime',
  TIME = 'time',
  TEXT = 'text',
  INDEX = 'index',
  INDEX_BORDER = 'indexBorder',
  PROGRESS = 'progress',
  PERCENT = 'percent',
  DIGIT = 'digit',
  NUMBER_ONLY = 'numberOnly',
  AVATAR = 'avatar',
  CODE = 'code',
  SWITCH = 'switch',
  RADIO = 'radio',
  RADIO_BUTTON = 'radioGroup',
  ARRAY_IDS = 'arrayIds',
}
